var map = {
	"./autocar.png": "dab8",
	"./computer.png": "dee9",
	"./google.png": "2fbf",
	"./mcdonalds.png": "b53d",
	"./moller.png": "9c39",
	"./nyit.png": "d26b",
	"./profile.jpg": "de34",
	"./sole1.png": "77a8",
	"./sort.png": "3a17",
	"./terminal.png": "4436",
	"./website1.png": "d20c",
	"./wip.png": "8bca"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3914";